import { render, staticRenderFns } from "./password-change.vue?vue&type=template&id=75d7f2f3&scoped=true&"
import script from "./password-change.vue?vue&type=script&lang=js&"
export * from "./password-change.vue?vue&type=script&lang=js&"
import style0 from "./password-change.vue?vue&type=style&index=0&id=75d7f2f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d7f2f3",
  null
  
)

export default component.exports